module.exports = __webpack_public_path__ + "static/media/erwatodaye.3a5a46bb.jpg";